import { createSelector } from 'reselect';

const modalSelector = state => state.modal;

export const selectModals = createSelector(modalSelector, modals => modals || {});
export const selectActiveModal = createSelector(selectModals, modals => {
  const modalName = Object.keys(modals).find(name => modals[name].isOpen);
  return {
    modalName: modalName || false,
    modalProps: modalName ? modals[modalName].props : {},
  };
});
